import Rooms from './Rooms';

export default Rooms;